import { makeStyles } from '@rbx/ui';

const useSnackbarStyles = makeStyles()((theme) => ({
  errorSnack: {
    background: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));

export default useSnackbarStyles;
